import getConfig from 'next/config';
import type { AxiosResponse } from 'axios';

// This seems like it should not be imported here
// Move APIs below into car finance folder?
import {
  VALIDATE_STEP_PATHS,
  type FormPayloadSchema,
  type LoanRequest,
} from '../components/CarFinancePage/queries/schema/carFinance.schema';
import { motorFinanceGateway } from '../api/api-utils/commonApiUtils';

const getCarFinance = (params: string) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  return motorFinanceGateway.get(`/v1/finance/application/load${params}`, {
    timeout: API_CLIENT_TIMEOUT,
  });
};

const loan = (payload: LoanRequest) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  return motorFinanceGateway.post('/v1/finance/calculate/loan', payload, {
    timeout: API_CLIENT_TIMEOUT,
  });
};

const submit = (payload: FormPayloadSchema) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  return motorFinanceGateway.post<AxiosResponse<unknown>>(
    '/v1/finance/application/apply',
    payload,
    {
      timeout: API_CLIENT_TIMEOUT,
    },
  );
};

const validateStep = (step: number, payload: FormPayloadSchema) => {
  const {
    publicRuntimeConfig: { API_CLIENT_TIMEOUT },
  } = getConfig();
  const path = VALIDATE_STEP_PATHS[step];
  if (!path) {
    throw new Error(`No validate path mapped for finance step ${step}`);
  }
  return motorFinanceGateway.post(
    `/v1/finance/application/validate/${path}`,
    payload,
    {
      timeout: API_CLIENT_TIMEOUT,
    },
  );
};

export const carFinanceApi = {
  getCarFinance,
  loan,
  submit,
  validateStep,
};
